import React from 'react';
import SpecificationInterface from 'interfaces/specification.interface';
import './product-specification-desktop.scss';

interface ProductSpecificationProps {
    specification: SpecificationInterface[];
}

const ProductSpecificationDesktop: React.FC<ProductSpecificationProps> = ({ specification }) => (
    <div className="specification">
        {
            specification.map(specificationItem => (
                <div className="specification__group" key={specificationItem.group}>
                    <div className="specification__group-label">
                        {specificationItem.group}
                    </div>
                    {
                        specificationItem.items.map(item => (
                            <div key={item.label} className="specification__group-item">
                                <div className="specification__group-item__label">
                                    {item.label}
                                    {':'}
                                </div>
                                <div className="specification__group-item__value">
                                    {item.value}
                                </div>
                            </div>
                        ))
                    }
                </div>
            ))
        }
    </div>
);

export default ProductSpecificationDesktop;
